module.exports = __webpack_public_path__ + "static/media/news-fallback.fba6138a.webp";